export default {
  apiKey: 'AIzaSyCaKTfDu_N9h_BCrwJvHWQXpuFR9MYBpTc',
  authDomain: 'tomin-f37c2.firebaseapp.com',
  databaseURL: 'https://tomin-f37c2.firebaseio.com',
  projectId: 'tomin-f37c2',
  storageBucket: 'tomin-f37c2.appspot.com',
  messagingSenderId: '699979886324',
  appId: '1:699979886324:web:01304f58c3a792851f38a1'
};
